import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';

interface RequestUpdateAvatarPropertyParams {
	id: string;
	avatar: File;
}

export function useUpdateAvatarProperty() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation({
		mutationFn: async ({ id, avatar }: RequestUpdateAvatarPropertyParams) => {
			try {
				const formData = createFormData({ file: avatar });
				return (await api.put(`/user/prop/updateAvatar/${id}`, formData, {
					params: { forBinding },
				})).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar avatar da propriedade');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['properties'] });
			queryClient.invalidateQueries({ queryKey: ['propertyId', variables.id] });
		},
		onError: (error) => {
			console.error(
				'Erro ao atualizar avatar da propriedade:',
				getApiErrorMessage(error, 'Erro ao atualizar avatar da propriedade')
			);
		},
	});
}
